import apiClient from "../core/HttpClient";
import { Charity } from "../models";

export default class CharityService{
    url="/Charities";

    public async getCharities(): Promise<Charity[]> {
        return await apiClient.get(this.url).then((res) => res.data);
    }

    public async getCharityById(id: number): Promise<Charity> {
        return await apiClient.get(`${this.url}/${id}`).then((res) => res.data);
    }

    public async createCharity(charity: Charity) {
        return await apiClient.post(this.url, charity);
    }

    public async updateCharity(charity: Charity) {
        return await apiClient.put(`${this.url}`, charity);
    }

    public async deleteCharity(id: number) {
        return await apiClient.delete(`${this.url}/${id}`);
    }
    
}
